module.exports = __webpack_public_path__ + "static/media/Usage.e924cd41.jpeg";